export default __webpack_public_path__ + "images/poppy-money-ship.png";